import { APP_TRANSACTION, TRANSACTION_HISTORY } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "api/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { isEmpty } from "lodash";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { MobiSimRegistrationRequestModel } from "./model/MobiSimRegistrationRequestModel";
import { MobiSimRegistrationResponseModel } from "./model/MobiSimRegistrationResponseModel";

export interface IMobiSimRegistrationRepository {
  getList(
    params: MobiSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<MobiSimRegistrationResponseModel>>;
  getDetail(
    params: MobiSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>>;
  exportReport(
    params: MobiSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>>;
  checkStatus(
    code: string
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>>;
}

@injectable()
export class MobiSimRegistrationImpl implements IMobiSimRegistrationRepository {
  async getList(
    params: MobiSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    return await client?.get(
      `${TRANSACTION_HISTORY.MOBISIMLIST}${
        !isEmpty(queryString) ? `?${queryString}` : ""
      }`,
      params
    );
  }
  async getDetail(
    params: MobiSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    return;
  }
  async exportReport(
    params: MobiSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    const queryParams = new URLSearchParams(
      params as unknown as URLSearchParams
    )?.toString();
    const url = `${TRANSACTION_HISTORY.MOBISIMLIST}${
      !isEmpty(queryString) ? `?${queryString}` : ""
    }${isEmpty(queryString) ? `?${queryParams}` : `&${queryParams}`}`;
    const token = DataFormat.getToken();
    const alterToken = DataFormat.getAlterToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token ? token : alterToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to export report: ${response.statusText}`);
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
  async checkStatus(
    code: string
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    return await client?.get(APP_TRANSACTION?.CHECK_STATUS, { code });
  }
}
